import { NavigationContext } from '@layout/navigation/navigation';
import { useContext } from 'react';
import { IdentificationRequestsQuery } from './IdentificationRequests.query';

const IdentificationRequests = () => {
  const { isSuperAdmin } = useContext(NavigationContext);

  if (!isSuperAdmin) {
    return <div />;
  }
  return <IdentificationRequestsQuery />;
};

export { IdentificationRequests };
